import React from "react";
import { CourseValidationError } from "src/types/coaching/courses";

export interface CourseContextProps {
  id?: string;
  courseContent?: any;
  preferences?: any;
  validationError?: CourseValidationError;
  
  showValidationErrorDialog?: boolean;
  
  // eslint-disable-next-line no-unused-vars
  setShowValidationErrorDialog?: (show: boolean) => void;

  // eslint-disable-next-line no-unused-vars
  gotoError(error?: CourseValidationError): void;
  
  // eslint-disable-next-line no-unused-vars
  updatePreferences?: (preferences: any) => void;

  // selectedContentId?: string | null;
  // selectedContentSectionId?: string | null;
  // handleSectionContentClick?: (itemId: string, parent: string | null) => void;
}

export const CourseContext = React.createContext<CourseContextProps>({
  gotoError: () => {},
  // selectedContentId: null,
  // selectedContentSectionId: null,
  // handleSectionContentClick: () => {},
});
